<template>
  <ul>
    <li
      class="p-4 mb-3 flex justify-between items-center bg-white shadow-md rounded-lg border border-white"
    >
      <div class="flex flex-col items-center">
        <!-- <p class="ml-2 text-gray-700 font-semibold font-sans tracking-wide">
        {{ polygon.title }}
      </p> -->
        <div class="ml-2 text-gray-700 font-semibold font-sans tracking-wide">
          <!-- <div class="aselect" :data-selectedClass="selectedClass" :data-list="list">
          <div class="selector" @click="toggleSelect()">
            <div class="px-4 cursor-pointer">
              <span>{{ selectedClass }}</span>
            </div>
            <div class="arrow" :class="{ expanded: visible }"></div>
            <div :class="{ hidden: !visible, visible }">
              <ul>
                <li v-bind:key="item.name" class="cursor-pointer" :class="{ current: item === selectedClass }"
                  v-for="item in temp" @click="select(item)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div> -->
          <t-select
            @change="selectedHandler($event)"
            :value="selectedClass"
            :options="nameList"
            :style="{
              color: polygon.color,
            }"
          >
          </t-select>
        </div>
        <div v-if="polygon.hasValue">
          <input
            class="ml-4 m-1 w-inherit rounded input px-2"
            v-model="polygon.value"
          />
        </div>
      </div>
      <div class="flex">
        <button
          aria-label="Edit polygon"
          class="action-button p-1 focus:outline-none focus:shadow-outline text-teal-500 hover:text-teal-600"
          @click="togglefunction(polygon.id)"
        >
          <EyeIcon v-if="toggle" />
          <EyeOffIcon v-else />
        </button>
        <button
          aria-label="Delete polygon"
          class="action-button p-1 focus:outline-none focus:shadow-outline text-red-500 hover:text-red-600"
          @click="$emit('deletePolygon', polygon.id, polygon.annotationId)"
        >
          <TrashIcon />
        </button>
      </div>
    </li>
  </ul>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import { TSelect } from "vue-tailwind/dist/components";
import VueTailwind from "vue-tailwind";
Vue.use(VueTailwind);
import {
  TrashIcon,
  PencilAltIcon,
  EyeIcon,
  EyeOffIcon,
} from "@vue-hero-icons/outline";
export default {
  data() {
    return {
      nameList: [],
      toggle: false,
      selectedClass: this.polygon.title,
      list: this.requiredFields,
      visible: false,
    };
  },

  watch: {},

  methods: {
    selectedHandler(event) {
      if (typeof event?.target?.value == "string") {
        let newValue = event?.target?.value;
        this.selectedClass = newValue;
        this.polygon.title = this.selectedClass;
        const selectedField = this.list.find(
          (element) => element.name == this.selectedClass
        );
        this.$emit(
          "changeClass",
          this.polygon.id,
          this.selectedClass,
          selectedField.id
        );
      }
    },

    togglefunction(polygonId) {
      this.toggle = !this.toggle;
      this.$emit("toggle", polygonId);
    },
    // toggleSelect() {
    //   this.visible = !this.visible;
    // },
    select(option) {
      this.selectedClass = option.name;
      this.polygon.title = this.selectedClass;
      const selectedField = this.list.find(
        (element) => element.name == this.selectedClass
      );
      this.$emit(
        "changeClass",
        this.polygon.id,
        this.selectedClass,
        selectedField.id
      );
    },
  },
  created() {
    let index = this.list.findIndex(
      (element) =>
        _.startCase(element.name).toLowerCase() ==
        this.selectedClass.toLowerCase()
    );

    this.list.forEach((element) => {
      this.nameList.push(element.name);
    });
    if (index > 0) {
      let temp = this.nameList[index];
      this.nameList[index] = this.nameList[0];
      this.nameList[0] = temp;
    }
  },

  components: {
    TSelect,
    EyeIcon,
    EyeOffIcon,
    TrashIcon,
  },
  props: {
    requiredFields: Array,
    polygon: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style>
select {
  border: none !important;
}
</style>
